import { array, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ClientId } from '../../client/Id';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';
export const FilterRequest = struct({
	client: array(ClientId),
	requirements: array(array(RequirementId)),
	createdAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
});
